<template>
	<div class="container px-0" id="FeelingsLog" style="max-width: 730px;">
		<div class="page-header gold mt-4">
      <back-btn to="/dashboard"></back-btn>
      <h2 class="mb-2">Contractions</h2>
		</div>
		<p class="instructional-text text-center mt-1">Log contractions as they arise. Tick them off once you've processed them.</p>

		<div class="mt-4">
			<div class="w-100">
				<healing-log :userid="parseInt(this.$route.params.user_id)" :limit="200" />
			</div>
		</div>
	</div>
</template>

<script>
import HealingLog from '../components/HealingLog.vue';
import BackBtn from "@/components/BackBtn.vue";

export default {
	name: 'Healing',
	components: {
    BackBtn,
		HealingLog,
	},

	data() {
		return {};
	},

	methods: {},

	mounted() {},

	computed: {},
	watch: {},
};
</script>

<style scoped>
.instructional-text {
  font-size: 0.9rem;
  color: #888;
  margin-top: 6px;
  margin-bottom: 0;
  font-style: italic;
}
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
  position: relative;
}
</style>
